import React, { useContext } from 'react';
import UserContext from 'contexts/UserContext';

import { Column } from 'components/Layouts/Flow';
import { Input } from 'components/Form';

const Address = ({ errors }) => {
	// Use user's context
	const { user, handleUser } = useContext(UserContext);

	// Handles input's onChange event
	// @event: object | native onChange event
	const onChange = event => {
		const { name, value } = event.target || event;
		handleUser({
			type: 'ON_CHANGE_ADDRESS',
			payload: { name, value }
		});
	};

	return (
		<>
			<Column size="12" className="withMarginTop">
				<h2>Addrese</h2>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="country"
					label="Valsts"
					value={user.address.country}
					error={errors.country}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="city"
					label="Pilsēta"
					value={user.address.city}
					error={errors.city}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="street"
					label="Iela"
					value={user.address.street}
					error={errors.street}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="zip"
					label="Pasta indeks"
					value={user.address.zip}
					error={errors.zip}
					onChange={onChange}
				/>
			</Column>
		</>
	);
};

export default Address;
